import { render, staticRenderFns } from "./RoleMappingConfig.vue?vue&type=template&id=775a020e"
import script from "./RoleMappingConfig.vue?vue&type=script&lang=js"
export * from "./RoleMappingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports